/**
 * Client-side entry for analytics consent revoke (P3.1.2 — single owner).
 */
import type { ApiClient } from '../api/ApiClient.js';
import { createCustomerAnalyticsClient } from './customerAnalyticsClient.js';
import { performAnalyticsConsentRevoke } from './analyticsConsentRevoke.js';

export interface OrchestrateClientRevokeInput {
  readonly tenantCode: string;
  readonly api: ApiClient;
  readonly sessionIds: readonly string[];
  /** Caller reads ONCE at start — never after clear. */
  readonly anonymousKey: string | null;
  readonly clearLocalAfterSuccess: boolean;
}

export async function orchestrateAnalyticsConsentRevokeFromClient(
  input: OrchestrateClientRevokeInput,
): Promise<void> {
  await performAnalyticsConsentRevoke({
    tenantCode: input.tenantCode,
    sessionIds: input.sessionIds,
    anonymousKey: input.anonymousKey,
    client: createCustomerAnalyticsClient(input.api),
    clearLocalAfterSuccess: input.clearLocalAfterSuccess,
  });
}
